import React, { useState, useEffect } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

function CountDownBanner(props) {
  const days = [
    "Domenica",
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
  ];
  const months = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  const calculateTimeLeft = () => {
    //let year = new Date().getFullYear();
    //const difference = +new Date(`${year}-10-1`) - +new Date();
    let shippingDate = new Date(
      props.timer_spedizioni.time_spedizione.unix_time * 1000
    );
    //let deliveryDate = new Date(props.time_consegna.unix_time * 1000);
    let now = Date.now();
    let elapsed = now - props.timer_spedizioni.local.timestamp; // elapsed local time in msec
    let adjNow = new Date(
      props.timer_spedizioni.now.unix_time * 1000 + elapsed
    );
    const difference = +shippingDate - adjNow;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        Giorni: Math.floor(difference / (1000 * 60 * 60 * 24)),
        Ore: Math.floor((difference / (1000 * 60 * 60)) % 24),
        Minuti: Math.floor((difference / 1000 / 60) % 60),
        //Secondi: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000); // update each min (60 secs)
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  if (!props.timer_spedizioni) return null;

  let delDate = new Date(props.timer_spedizioni.time_consegna.unix_time * 1000);
  let delMonthDay = delDate.getDate();
  let delMonth = delDate.getMonth();
  let delDay = delDate.getDay();

  /*
        <div className="mappa_banner" >
          <div id="AW-modalHdr">
            <div
              className="ico-close-modal"
              title="Chiudi"
              onClick={()=>setShowMap(false)}
            >
              <img src="/images/chiusura_modal_on.svg" alt="close" />
            </div>
          </div>

          <img
            src="/images/italia_spedizioni.jpg"
            alt="mappa dei tempi di spedizione in Italia"
            title="mappa dei tempi di spedizione in Italia"
          />
        </div>

  */

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  if (timerComponents.length === 0) 
    return null;

  return (
    <>
      <div className="timeout_banner" onClick={() => setShowMap(true)}>
        <p>
          Vuoi il tuo ordine <span className="sottolineato">{days[delDay]} {delMonthDay} {months[delMonth]}</span>? *
          Ordina entro:{" "}
          {timerComponents.length ? (
            timerComponents
          ) : (
            <span>Tempo Scaduto!</span>
          )}
        </p>
      </div>
      {showMap === true ? (
        <Dialog open={true}>
          <DialogTitle>Tempi di spedizione in Italia</DialogTitle>

          <DialogContent>
            <img
              src="/images/italia_spedizioni.jpg"
              alt="mappa dei tempi di spedizione in Italia"
              title="mappa dei tempi di spedizione in Italia"
            />
            <p>
              <span className="evidenza">Attenzione</span>, i tempi di spedizione possono variare a
              causa di forza maggiore.
              <br /><span className="bold">*</span> Escluso Venezia, isole minori o zone disagiate.
            </p>
            <div
              className="chiudi_popup_button"
              onClick={() => setShowMap(false)}
            >
              Chiudi
            </div>
          </DialogContent>
        </Dialog>
      ) : null}
    </>
  );
}

export default CountDownBanner;